const QUERY_CONTENT = `
    *[_type == "features"][0]
`;

export default QUERY_CONTENT;
